import { RemoteConstantsModel } from "../models/remoteConstants.model";
import {CommandBase} from "./commandBase";

export class AddBuildingRewardCommand extends CommandBase {
    id: string;
    rewardUid: string;
    level: number;

    constructor(id: string, rewardUid: string, level: number) {
        super();
        this.id = id;
        this.rewardUid = rewardUid;
        this.level = level;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.buildings.findIndex(b => b.id === this.id);
        if (index < 0) {
            return false;
        }

        data.buildings[index].rewards[this.level].push(this.rewardUid);
        return true;
    }
}